import React from "react"
import MainBanner from "./elements/main-banner"
import Intro from "./elements/intro"
import Description from "./elements/description"
import Testimonial from "./elements/testimonial"
import StorySection from "./elements/stories"
import FullScreenSection from "./elements/full-screen-section"
import ContainerSection from "./elements/container-section"
import HighlyRecommended from "./elements/highly-recommended"
import MusicOptions from "./elements/music-options-strapi"
import PackageOptions from "./elements/package-options"
import BandSlide from "./elements/band-slide"
import WeddingSongPlan from "./elements/wedding-song-plan"
import PackageBuilder from "./elements/package-builder"
import Redline from "./background-red-line"
import Faq from "./elements/faq"
import BandTypeGaleries from "./elements/band-type-galeries"
import BandTypeRecommended from "./elements/band-type-recomended"
import Suppliers from "./elements/suppliers"
import HtmlContent from "./elements/html-content"
import EmbedCeremonyVideo from "./elements/embed-ceremony-video"
import EmbedReceptionVideo from "./elements/embed-reception-video"
import EmbedSingersVideo from "./elements/embed-singers-video"
import Venues from "./elements/venues"
import StartHere from "./elements/start-here"
import BlogsRecommender from "./elements/blogs-recommender"
import VideoListFromJson from "./elements/video-list-from-json"
import EmbedRequestCallBackModal from "./elements/embed-request-callback"

function DynamicComponent({ component, params }) {
  const {
    type,
    title,
    data,
    options,
    reverse,
    suppliers,
    htmlContent,
    htmlLeft,
    htmlRight,
    htmlDesc,
    list,
    htmlTitle,
    faqs,
    bands,
    subTitle,
    blogs,
    images,
    buttonViewAllBlogs,
    borderBottom,
    borderTop,
    underline,
    defaultTab,
    defaultSubTab,
    html,
  } = component

  switch (type) {
    case "Banner":
      return <MainBanner data={data.data} />
    case "Intro":
      return <Intro data={data.data} />
    case "Description":
      return <Description data={data.data} />
    case "Testimonial":
      return <Testimonial data={data.data} title={title} reverse={reverse} />
    case "StorySection":
      return <StorySection data={data.data} />
    case "FullScreenSection":
      return <FullScreenSection data={data.data} />
    case "ContainerSection":
      return <ContainerSection data={data.data} />
    case "HighlyRecommended":
      return <HighlyRecommended params={params} />
    case "Redline":
      return <Redline />
    case "MusicOptions":
      return (
        <MusicOptions
          musicOptions={options}
          title={title}
          underline={underline}
          borderTop={borderTop}
        />
      )
    case "PackageOption":
      return (
        <PackageOptions
          packageOptions={options}
          title={title}
          htmlDesc={htmlDesc}
        />
      )
    case "BandSlide":
      return (
        <BandSlide
          bands={bands}
          subTitle={subTitle}
          title={title}
          htmlTitle={htmlTitle}
          html={html}
        />
      )
    case "WeddingSongPlan":
      return (
        <WeddingSongPlan
          htmlLeft={htmlLeft}
          htmlRight={htmlRight}
          borderBottom={borderBottom}
        />
      )
    case "EmbedCeremonyVideo":
      return (
        <EmbedCeremonyVideo
          location={params.location}
          htmlContent={htmlContent}
        />
      )
    case "EmbedReceptionVideo":
      return (
        <EmbedReceptionVideo
          location={params.location}
          htmlContent={htmlContent}
        />
      )
    case "EmbedSingersVideo":
      return (
        <EmbedSingersVideo
          location={params.location}
          htmlContent={htmlContent}
        />
      )
    case "Venues":
      return <Venues htmlTitle={htmlTitle} images={images} />
    case "StartHere":
      return <StartHere data={component} />
    case "BlogsRecommender":
      return (
        <BlogsRecommender
          blogs={blogs}
          htmlTitle={htmlTitle}
          buttonViewAllBlogs={buttonViewAllBlogs}
          params={params}
        />
      )
    case "PackageBuilder":
      return <PackageBuilder />
    case "faq":
      return <Faq faqs={faqs} />
    case "BandTypeGaleries":
      return <BandTypeGaleries />
    case "BandTypeRecommended":
      return <BandTypeRecommended htmlLeft={htmlLeft} htmlRight={htmlRight} />
    case "VideoListFromJson":
      if (!list) {
        return <div></div>
      }
      return (
        <VideoListFromJson
          list={list}
          htmlTitle={htmlTitle}
          defaultTab={defaultTab}
          defaultType={defaultSubTab}
        />
      )
    case "Suppliers":
      return <Suppliers data={suppliers.data} title={title} />
    case "HtmlContent":
      return <HtmlContent data={htmlContent} />
    case "HtmlFreeStyle":
      return <div dangerouslySetInnerHTML={{ __html: htmlContent || "" }} />
    case "RequestCallBackModal":
      return <EmbedRequestCallBackModal location={params.location} />
    default:
      return <div></div>
  }
}

export default DynamicComponent
